import Vue from 'vue';
import Vuetify from 'vuetify';
import { VuetifyPreset } from 'vuetify/types/services/presets';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';
import colors from 'vuetify/lib/util/colors'


Vue.use(Vuetify);

const opts: Partial<VuetifyPreset> = {
  theme: {
    dark: false,
    default: "light",
    disable: false,
    options: {},
    themes: {
      light: {
        primary: colors.blue,
        secondary: colors.lightBlue.darken3,
        accent: colors.orange,
        error: colors.red,
        warning: colors.amber,
        info: colors.lightBlue,
        success: colors.lightGreen.accent4,
      },
      dark: {
        primary: colors.blue.darken1,
        secondary: colors.lightBlue.darken4,
        accent: colors.orange.darken1,
        error: colors.red.darken1,
        warning: colors.amber.darken1,
        info: colors.lightBlue.darken1,
        success: colors.lightGreen.darken1,
      },
    },
  },
  icons: {
    iconfont: "mdi",
    values: {},
  },
};

export default new Vuetify(opts);
